<template>
  <main :class="$style.view" v-if="page.fields">
    <about-nav :items="navItems" :class="$style.nav" ref="nav" />
    <div :class="$style.wrapper">
      <repeater-matrix
        :items="page.fields.content"
        :class="$style.content"
        ref="content"
      />
      <base-bodytext :text="page.fields.body" :class="$style.credits" />
    </div>
  </main>
</template>

<script>
import PageService from '@/services/page'
import AboutNav from '@/components/about-nav'
import BaseBodytext from '@/components/base-bodytext'
import RepeaterMatrix from '@/components/repeater-matrix'
import scrollama from 'scrollama'

export default {
  components: {
    AboutNav,
    BaseBodytext,
    RepeaterMatrix
  },
  metaInfo() {
    return {
      title: this.page.fields ? this.page.fields.title : ''
    }
  },
  data() {
    return {
      page: {},
      loading: true,
      scrollama: undefined,
      mediaQuery: undefined,
      // TODO: Offset should be different depending on scroll direction, but Scrollama doesn’t seem to support that
      defaultOffset: 0,
      offset: this.defaultOffset
    }
  },
  computed: {
    navItems() {
      return this.page.fields.content.filter(
        item => item.type === 'type_section'
      )
    }
  },
  methods: {
    initScrollama() {
      // If scrollama has already been initialized, then only resize Scrollama
      if (this.scrollama) {
        this.resizeScrollama()
        return
      }

      // Instantiate scrollama
      this.scrollama = scrollama()

      // TODO: temp workaround until offsetTrigger updates scrollama correctly
      this.setOffset()

      const children = this.$refs.content.$children
      const elements = children.map(child => child.$el)
      // only use these elements with an id to match with navItems
      const filteredElements = elements.filter(el => el.id !== '')

      this.scrollama
        .setup({
          step: filteredElements,
          offset: this.offset
        })
        .onStepEnter(response => {
          this.$store.commit('currentSection', response.index)
        })

      // TODO: Activate when offsetTrigger updates scrollama correctly
      // this.resizeScrollama()
    },
    setOffset() {
      const mobileOffset =
        (this.$refs.nav.$el.clientHeight * 100) / window.innerHeight / 100
      this.offset = this.mediaQuery.matches ? this.defaultOffset : mobileOffset
      // TODO: Activate when offsetTrigger updates scrollama correctly
      // this.scrollama.offsetTrigger(this.offset)
    },
    resizeScrollama() {
      if (!this.scrollama) return
      // TODO: Activate when offsetTrigger updates scrollama correctly
      // this.setOffset()
      this.scrollama.resize
    }
  },
  async created() {
    this.page = await PageService.get({ id: this.$route.name })
    this.loading = false
  },
  mounted() {
    this.mediaQuery = window.matchMedia('(min-width: 48em)')
  },
  activated() {
    document.documentElement.classList.add('about-view')
  },
  deactivated() {
    document.documentElement.classList.remove('about-view')
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeScrollama)
    this.scrollama.destroy()
  },
  watch: {
    loading() {
      this.$nextTick(() => {
        this.initScrollama()
        window.addEventListener('resize', this.resizeScrollama)
      })
    }
  }
}
</script>

<style lang="scss">
.about-view {
  background-color: var(--black);
}
</style>

<style lang="scss" module>
.view {
  padding: calc(var(--blank-line) * 6.3) var(--gutter) 0;
  min-height: 100vh;
  color: var(--dark-grey);
  background-color: var(--black);

  @media (min-width: $xxsmall) {
    padding-top: calc(var(--blank-line) * 4.45);
  }

  @media (min-width: $medium) {
    display: flex;
    padding-top: calc(var(--blank-line) * 4.8);
  }
}

.wrapper {
  position: relative;

  @media #{$mqHover} {
    transition: color var(--short) ease;

    a:hover {
      color: var(--dark-grey);
    }
  }

  @media (min-width: $medium) {
    flex: 4;
    // "Remove" margin of first content item
    margin-top: calc(var(--blank-line) * -1);
  }
}

.content {
  > :last-child {
    margin-bottom: 0;
    min-height: calc(100vh + var(--gutter) - var(--about-nav-height));
  }

  @media (min-width: $medium) {
    > :last-child {
      min-height: calc(100vh - var(--blank-line));
    }
  }
}

.credits {
  position: absolute;
  bottom: var(--gutter);

  @media #{$mqHover} {
    transition: color var(--short) ease;

    a:hover {
      color: var(--white);
    }
  }
}
</style>
